import React from "react";

function DoubleSideRotary() {
  return (
    <>
      <style>{`
      .technical-spec-section {
        margin: 40px 0;
        overflow-x: auto;
      }
      .technical-spec-section h4 {
        font-family: 'Oxygen', sans-serif;
        font-weight: bold;
        font-size: 24px;
        color: #000;
        margin-bottom: 20px;
      }
      .table {
        width: 100%;
        border-collapse: collapse;
        background: white;
      }
      .table-bordered {
        border: 1px solid #ddd;
      }
      .table-bordered td {
        border: 1px solid #ddd;
        padding: 12px 15px;
        font-size: 14px;
      }
      .table tbody tr:nth-child(even) {
        background-color: #f2f2f2;
      }
      .table td:first-child {
        font-weight: 600;
        width: 40%;
      }
    `}</style>

      <main id="primary" className="site-main">
        <div className="space-for-header"></div>

        {/* Breadcrumb Section */}
        <section
          className="tj-page-header section-gap-x"
          data-bg-image="assets/images/bg/pheader-bg.webp"
        >
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="tj-page-header-content text-center">
                  <h1 className="tj-page-title">Double Side Rotary Tableting Machine</h1>
                  <div className="tj-page-link">
                    <span><i className="fa-solid fa-home"></i></span>
                    <span><a href="/">Home</a></span>
                    <span><i className="fa-solid fa-arrow-right"></i></span>
                    <span><span>Double Side Rotary Tableting Machine</span></span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            className="page-header-overlay"
            data-bg-image="assets/images/shape/pheader-overlay.png"
          ></div>
        </section>

        {/* MAIN CONTENT */}
        <section className="tj-blog-section section-gap slidebar-stickiy-container">
          <div className="container">
            <div className="row row-gap-5">
              
              {/* LEFT CONTENT */}
              <div className="col-lg-8">
                <div className="post-details-wrapper">

                  {/* MAIN IMAGE */}
                  <div className="blog-images wow fadeInUp" data-wow-delay=".1s">
                    <img
                      src="assets/images/SD_PHRMA_ALL_MIX _JPGS/7.png"
                      alt="Double Side Rotary Tableting Machine"
                      style={{ width: "100%", maxHeight: "500px", objectFit: "cover" }}
                    />
                  </div>

                  <h2 className="title title-anim">
                    Double Side Rotary Tableting Machine
                  </h2>

                  <div className="blog-text">
                    <p className="wow fadeInUp" data-wow-delay=".3s">
                      The Double Side Rotary Tableting Machine is engineered for
                      medium-to-large scale tablet manufacturing. With dual-sided
                      compression and precision control, it provides higher output
                      while ensuring uniform tablet hardness and weight accuracy.
                    </p>

                    <p className="wow fadeInUp" data-wow-delay=".4s">
                      This model is ideal for pharmaceutical, nutraceutical, and
                      chemical industries requiring efficient tablet compression
                      with high reliability, strong build quality, and smooth
                      operation. It includes safety interlocks, sturdy SS
                      construction, and ergonomic design for continuous operation.
                    </p>
                  </div>

                  {/* EXTRA IMAGES */}
                  <div className="images-wrap">
                    <div className="row">

                      <div className="col-sm-6">
                        <div className="image-box wow fadeInUp" data-wow-delay=".3s">
                          <img src="assets/images/SD_PHRMA_ALL_MIX _JPGS/8.png" alt="Image" />
                        </div>
                      </div>

                      <div className="col-sm-6">
                        <div className="image-box wow fadeInUp" data-wow-delay=".5s">
                          <img src="assets/images/SD_PHRMA_ALL_MIX _JPGS/9.png" alt="Image" />
                        </div>
                      </div>

                    </div>
                  </div>

                  {/* TECHNICAL SPECIFICATIONS */}
                  <div className="technical-spec-section">
                    <h4>Technical Specification</h4>

                    <table className="table table-bordered">
                      <tbody>

                        <tr>
                          <td>Model</td>
                          <td>DPM-H-27</td>
                          <td>DPM-H-33</td>
                          <td>DPM-H-45</td>
                          <td>DPM-H-55</td>
                        </tr>

                        <tr>
                          <td>Number of Stations</td>
                          <td>27</td>
                          <td>33</td>
                          <td>45</td>
                          <td>55</td>
                        </tr>

                        <tr>
                          <td>Output (Tablets / Hour)</td>
                          <td>162,000</td>
                          <td>198,000</td>
                          <td>270,000</td>
                          <td>330,000</td>
                        </tr>

                        <tr>
                          <td>Max Tablet Diameter</td>
                          <td>25 mm</td>
                          <td>25 mm</td>
                          <td>16 mm</td>
                          <td>16 mm</td>
                        </tr>

                        <tr>
                          <td>Max Depth of Fill</td>
                          <td>20 mm</td>
                          <td>20 mm</td>
                          <td>17 mm</td>
                          <td>17 mm</td>
                        </tr>

                        <tr>
                          <td>Main Compression Pressure</td>
                          <td>10 Tons</td>
                          <td>10 Tons</td>
                          <td>6.5 Tons</td>
                          <td>6.5 Tons</td>
                        </tr>

                        <tr>
                          <td>Pre-Compression</td>
                          <td>2 Tons</td>
                          <td>2 Tons</td>
                          <td>1 Ton</td>
                          <td>1 Ton</td>
                        </tr>

                        <tr>
                          <td>Turret Speed</td>
                          <td>30 RPM</td>
                          <td>30 RPM</td>
                          <td>30 RPM</td>
                          <td>30 RPM</td>
                        </tr>

                        <tr>
                          <td>Main Motor</td>
                          <td>5 HP</td>
                          <td>5 HP</td>
                          <td>5 HP</td>
                          <td>5 HP</td>
                        </tr>

                        <tr>
                          <td>Machine Dimensions (L × W × H)</td>
                          <td>1700 × 1650 × 1900 mm</td>
                          <td>1700 × 1650 × 1900 mm</td>
                          <td>1700 × 1650 × 1900 mm</td>
                          <td>1700 × 1650 × 1900 mm</td>
                        </tr>

                        <tr>
                          <td>Machine Weight</td>
                          <td>2100 kg</td>
                          <td>2200 kg</td>
                          <td>2300 kg</td>
                          <td>2400 kg</td>
                        </tr>

                      </tbody>
                    </table>
                  </div>

                </div>
              </div>

              {/* RIGHT SIDEBAR */}
              <div className="col-lg-4 sidebar-container">
                <div className="tj-main-sidebar">

                  <div className="tj-sidebar-widget service-categories">
                    <h4 className="widget-title">Related Products</h4>
                    <ul>
                      <li>
                        <a href="/single-rotary-tablet-press">
                          Single Rotary Tablet Press
                          <span className="icon"><i className="fa-solid fa-arrow-right"></i></span>
                        </a>
                      </li>

                      <li>
                        <a href="/mini-tablet-press">
                          Mini Tablet Press
                          <span className="icon"><i className="fa-solid fa-arrow-right"></i></span>
                        </a>
                      </li>

                      <li>
                        <a href="/r-d-tablet-press">
                          R&D Tablet Press
                          <span className="icon"><i className="fa-solid fa-arrow-right"></i></span>
                        </a>
                      </li>

                      <li>
                        <a href="/multi-layer-tablet-press">
                          Multi Layer Tablet Press
                          <span className="icon"><i className="fa-solid fa-arrow-right"></i></span>
                        </a>
                      </li>

                      <li>
                        <a href="/lab-tablet-press">
                          Lab Tablet Press
                          <span className="icon"><i className="fa-solid fa-arrow-right"></i></span>
                        </a>
                      </li>

                    </ul>
                  </div>

                </div>
              </div>

            </div>
          </div>
        </section>

      </main>
    </>
  );
}

export default DoubleSideRotary;
